import { ReportComponent } from './report/report.component';

export const components: any[] = [ReportComponent];

export * from './report/report.component';
